import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function removeOfferFromObservedAPI(authToken: string | null, offerId: string): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return jobHunterAPI.put(`api/offers/${offerId}/remove_from_observed`, {}, new RestQueryParams(), headers);
}
